import { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { interval, Subject, takeUntil } from "rxjs";
import {
  ColumnReportGenerate,
  LabelDownload,
  LabelGenerateReport,
  RelativeReportLoadingReport,
} from "./ModalReportGenerateStyled";
import { ReportProcessingContainer } from "../ModalGenerateReport/ModalGenerateReportStyled";
import GifDownloadReport from "../../../images/gif_download_talma.gif";
import "./ModalReportGenerate.css";
import { INTERVAL_3_SECONDS } from "../../../utils/valueStaticConstants";
interface Props {
  showProcessing: boolean;
  onChangeState: (stateModalGenerate: boolean) => void;
}
export const ModalReportGenerate = ({
  showProcessing = false,
  onChangeState,
}: Props) => {
  useEffect(() => {
    const componentUnmount$: any = new Subject();
    const timer$ = interval(INTERVAL_3_SECONDS).pipe(
      takeUntil(componentUnmount$)
    );

    const subscription = timer$.subscribe(() => {
      onChangeState(false);
    });
    return () => {
      subscription.unsubscribe();
      componentUnmount$.next();
      componentUnmount$.complete();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      style={{ width: "22.4rem", height: "20rem" }}
      className="success-report-talma-background"
      showHeader={false}
      visible={showProcessing}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <ReportProcessingContainer>
        <ColumnReportGenerate>
          <RelativeReportLoadingReport>
            <img
              src={GifDownloadReport}
              alt="download"
              className="img-processing-report"
            />
          </RelativeReportLoadingReport>
          <LabelGenerateReport>Reporte generado</LabelGenerateReport>
          <LabelDownload>Ir a ver descargas</LabelDownload>
        </ColumnReportGenerate>
      </ReportProcessingContainer>
    </Dialog>
  );
};
